import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonPatientResponse } from '@/api/services/common/patient/common-patient.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonRegimeResponse } from '@/api/services/common/case/common-case.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import {
    PaymentMethodResponse
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

export enum InvoiceStatus {
    GENERATED = 'GENERATED',
    CANCELLED = 'CANCELLED',
    VERIFIED = 'VERIFIED'
}
export interface InvoiceStatusEnumResponse extends EnumResponse {
    code: InvoiceStatus
}

export interface InvoiceResponse {
    id: number
    laboratory: CommonLaboratoryResponse
    label: string
    customer: StrictNullable<CustomerResponse>
    patient: StrictNullable<CommonPatientResponse>
    caseType: StrictNullable<CommonCaseTypeResponse>
    regime: StrictNullable<CommonRegimeResponse>
    status: InvoiceStatusEnumResponse
    generationDate: string
    canceller: StrictNullable<CommonPersonnelResponse>
    cancellationDate: StrictNullable<string>
    generator: StrictNullable<CommonPersonnelResponse>
    issueDate: StrictNullable<string>
    issuer: StrictNullable<CommonPersonnelResponse>
    verificationDate: StrictNullable<string>
    verifier: StrictNullable<CommonPersonnelResponse>
    isForAutoInvoice: boolean
    realTotalValue: StrictNullable<number>
    realAccountingUnit: StrictNullable<AccountingUnitResponse>
    externalReference: StrictNullable<string>
    paymentDate: StrictNullable<string>
    paymentMethod: StrictNullable<PaymentMethodResponse>
    sentToGovernmentRevenueServices: StrictNullable<boolean>
    conceptsTotalValue: StrictNullable<number>
    conceptsAccountingUnit: StrictNullable<AccountingUnitResponse>
    numberOfDeliveryNotes: number
    appliedBillableConceptsCount: number
}

export interface InvoicePatchRequest {
    id: number
    realTotalValue?: Nullable<number>
    realAccountingUnitId?: Nullable<number>
    externalReference?: Nullable<string>
    sentToGovernmentRevenueServices?: Nullable<boolean>
    paymentDate?: Nullable<string>
    paymentMethodId?: Nullable<number>
}

export interface InvoiceDeliveryNoteAddDetachRequest {
    deliveryNoteIds: number[]
}
